module.exports = __webpack_public_path__ + "img/register_pc_02.50d7cffb.png";